import { GroupType } from "./GroupType.d";


import {ID, ListRequest} from "../../../types/global.d";
import {displayTime, displayDate, displayDateTime} from "../../../utils/formatDate";
import {OrderBy} from "../../../types/global.d";

// Interface for entity ScopeGroups


export interface ScopeGroup {
    id: ID;

    
    name: string;

    
    hierarchyName: string;

    
    scopeGroupContext: string;

    
    description?: string;

    
    rootScopeGroupId: ID;

    
    parentScopeGroupId?: ID;

    
    membersGroupId?: ID;

    }

export interface FilterAdvancedPresentationRequest {
    list: ListRequest,
    filter: {
        
            name?: string,
        
    
    

            scopeGroupContext?: string,
        
    
    

            membersGroupId: ID[],
        
    
    membersGroupIdInclude: boolean,



        membersGroupIdRefs?: ID[],
        orderBys: OrderBy[],
        caseSensitive: boolean,
    },
}



export interface CreateScopeGroup {
    
    name: string;

    
    
    scopeGroupContext: string;

    
    description?: string;

    
    
    parentScopeGroupId?: ID;

    
    membersGroupId?: ID;

    }


export interface UpdateScopeGroup {
    
    name: string;

    
    
    scopeGroupContext: string;

    
    description?: string;

    
    
    
    }

export interface PresentationScopeGroupRequest {
    list: ListRequest,
    filter: {
        name: string,
        nameOr: boolean,
        membersGroupIdRefs?: ID[],
        orderBys: OrderBy[],
        caseSensitive: boolean,
    },
}

export class PrimaryScopeGroup {
    id: string;


    constructor(
        id: ID,
        ) {
        this.id = id?.toString();
        }

    static fromEntity(entity: ScopeGroup): PrimaryScopeGroup | undefined {
        return entity ? new PrimaryScopeGroup(
            entity.id,
        ) : undefined;
    }

    static fromId(id: ID
): PrimaryScopeGroup {
        return new PrimaryScopeGroup(
                id,
                );
    }
    
    static fromPath(path?: string): PrimaryScopeGroup {
        let vals = path?.split('/');
        return new PrimaryScopeGroup(
                   vals[0],
                );
    }

    static fromQuery(value?: string): number | undefined {
        return value ? value : undefined
    }

    toPath(): string {
        let ids = [
            this.id,
            ];
        return ids.join('/');
    }

    static toQueryParams(ids: PrimaryScopeGroup[]): string {
        return '?ids=' + ids.map(id => id.id).join('&ids=');
    }
}

export function toString(entity?: ScopeGroup): string {
    let fields = entity ? [
    entity.name,
            ] : [];
    return fields.filter(item => item).join(' | ');
}

export class UpdateEntityScopeGroup {
    id: PrimaryScopeGroup;
    data: UpdateScopeGroup;


    constructor(id: PrimaryScopeGroup, data: UpdateScopeGroup) {
        this.id = id;
        this.data = data;
    }
}
